<template>
  <div id="token-editor">

    <div v-if="loading">
      <div class="d-flex justify-content-center mb-8 mt-8">
        <memlist-spinner />
      </div>
      
    </div>
    <div v-else-if="client_id">

      <m-row>
        <m-col lg="12">
          <p style="font-weight: bold;">{{ $t('USER.INTEGRATION_STEPS') }}</p>
          <textarea
            v-model="code_to_integrate"
            class="ml-textarea"
            :disabled="true"
            style="font-family: monospace; height: 88px;"
          >
          </textarea>
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <span>{{$t('USER.CLIENT_ID')}}</span>
          <memlist-code-box :code="client_id" v-if="client_id" />
        </m-col>
      </m-row>
      <m-row class="mt-4">
        <m-col lg="12" v-if="client_secret.indexOf('****') !== -1">
          <memlist-text-input 
            :title="$t('USER.CLIENT_SECRET')"
            v-model="client_secret"
            :disabled="true"
          />
          <p>{{ $t('USER.CLIENT_SECRET_INFO') }}</p>
        </m-col>
        <m-col lg="12" v-else>
          <span>{{$t('USER.CLIENT_SECRET')}}</span>
          <memlist-code-box :code="client_secret" />
        </m-col>
      </m-row>

      <m-row>
        <m-col lg="12">
          <memlist-button @click="delete_oauth" variant="danger">{{ $t('USER.DELETE_OAUTH') }}</memlist-button>
        </m-col>
      </m-row>
      

    </div>
    <div v-else>
      <m-row>
        <m-col lg="12">
          <memlist-button @click="create_oauth" variant="primary">{{ $t('USER.CREATE_OAUTH') }}</memlist-button>
        </m-col>
      </m-row>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';

export default {
  name: 'TokenEditor',
  components: {
    
  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'pages']),
    code_to_integrate() {
      return ``;
    },
  },
  props: ['user'],
  async mounted() {

  },
  methods: {
    async delete_oauth() {
      this.loading = true;

      try {
        const res = await axios.post(`/access/user/${this.user.user_id}/oauth/credentials`, {});
        
        if (res.status === 204) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('USER.DELETED_OAUTH'));
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('USER.UNABLE_DELETE_OAUTH'));
        }
      }
      catch (err) {
        console.error('delete_oauth', err);
      }
    },

    async create_oauth() {
      this.loading = true;

      try {
        const res = await axios.post(`/access/user/${this.user.user_id}/oauth/credentials`, {});

        if (res.status === 201) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('USER.CREATED_OAUTH'));
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('USER.UNABLE_CREATE_OAUTH'));
        }
      }
      catch (err) {
        console.error('create_oauth', err);
      }
    },
  },
  data() {
    return {
      tmp: 'asdasdasdasdasdasdasd',
      client_secret: '***********************',
      client_id: null,
      loading: false,
    };
  },
  watch: {

  },

};
</script>
<style lang="scss" scoped>

:deep .v-treeview-node__root:hover {
  cursor: pointer;
}

.tree-panel {
  background-color: white;
}

:deep .v-simple-checkbox {
  float: left;
  width: 22px;
  margin-left: 8px;
}

:deep .v-input__slot label {
  font-size: 12px;
}

:deep .v-data-table__wrapper tr:first-child {
  height: 66px;
  background-color: rgb(239, 239, 239) !important;
}

</style>
